import $ from "jquery";

export default function(url, data) {
  $.ajax({
    url: url,
    dataType: 'json',
    data: data,
    success: (response) => {
      this.root.find('.data-results').html(response.results_partial)
    },
    error: (xhr, text, error) => {
      swal({
        type: 'error',
        title: xhr.statusText
      })
    }
  });

}
